import { render, staticRenderFns } from "./measure.vue?vue&type=template&id=81b6cc18&scoped=true&"
import script from "./measure.vue?vue&type=script&lang=ts&"
export * from "./measure.vue?vue&type=script&lang=ts&"
import style0 from "./measure.vue?vue&type=style&index=0&id=81b6cc18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b6cc18",
  null
  
)

export default component.exports